import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapHomeChartFields } = createHelpers({
  getterType: `homeChart/getField`,
  mutationType: `homeChart/updateField`
});

const state = {};

const actions = {
  gethomeChart({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post("DealerPortal/DealerOrdersChartData", request)
        .then(data => {
          let resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting homeCharts : " + err.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(err.message);
        });
    });
  }
};

const mutations = {
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
